'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { ConversionAssetPosition } from '../../constants/video';
import { formatCustomTime } from '../../utils/video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConversionAssetSummary = ({
  className,
  conversionAsset
}) => {
  if (!conversionAsset || !conversionAsset.type) {
    return null;
  }
  let position = conversionAsset.position || ConversionAssetPosition.PRE;
  if (position === ConversionAssetPosition.CUSTOM && !conversionAsset.overlay_delay_seconds) {
    position = ConversionAssetPosition.PRE;
  }
  const timeDisplay = formatCustomTime(conversionAsset.overlay_delay_seconds || 0);
  const positionEl = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `RichTextLib.video.conversionAssetSummary.position.${position.toLowerCase()}`,
    options: {
      timeDisplay
    }
  });
  const canSkipEl = /*#__PURE__*/_jsx(FormattedMessage, {
    message: conversionAsset.prevent_skip ? 'RichTextLib.video.conversionAssetSummary.preventSkip' : 'RichTextLib.video.conversionAssetSummary.allowSkip'
  });
  return /*#__PURE__*/_jsxs(UIList, {
    className: className,
    styled: true,
    children: [positionEl, canSkipEl]
  });
};
export default ConversionAssetSummary;